
import { useState,  useRef, useEffect } from 'react';
import { Disclosure, Popover } from '@headlessui/react'
import { usePopper } from 'react-popper'
import { cls as clsn } from 'views/NUI/utils'
import { Link } from "react-router";
import menu_model from 'models/menu_model'

const tiles = {
	grow: {
        img: "2/Rectangle306.jpg",
        list: [
            {
                title:'Become a Cosmetic Nurse',
                link:"/nurse"
            },
            {
                title:'Grow your Aesthetics Business',
                link:"/grow"
            },
            {
                title: "Meet our Clinical Advisory Committee",
                link: "/clinical-advisory-committee"
            }
        ]
    },
    support: {
        img: "2/Rectangle432.jpg",
        list: [
            {
                title: 'Medical Oversight & Complication Management',
                link: "/medical-oversight"
            }, 
            {
                title: 'Fast & Effective Software', 
                link: "/effective-software"
            },
            {
                title: 'Compliance & Safety', 
                link: "/complicance"
            },
            {
                title: 'Training & Events', 
                link: "/training-events"
            },
            {
                title: 'Cosmetic Support', 
                link: "/support"
            }]
    },
    why: {
        img: "2/Rectangle434.jpg",
        list: [
            {
                title: "Our Values",
                link: "/our-values"
            }, 
            {
                title: "Contact Us",
                link: "/contact"
            }
        ]
        
    },
    resources: {
        img: "2/qld-nurses-banner.jpg",
        list: [
            {
                title: 'FAQs',
                link: "/instantcosmetics-faqs"
            },
            // {
            //     title: 'Worried about the new S4s rule?',
            //     link: "/qld-cosmetic-nurses-urgent-update"
            // }
        ]
    }
}

// 		--------------------------------		--------------------------------		---------

const  IcosmMegaMenu = (props) => {
	const {inSideMenu, cls='main', onMenuChange } = props
	const [current, setCurrent] = useState();
    const btnRef = useRef([]);
	const [popperElement, setPopperElement] = useState()
	const {styles, attributes} = usePopper(btnRef, popperElement)
	const [mainMenu, setMenu] = useState([])
	const [panel, setPanel] = useState()
    const img_path = "https://storage.googleapis.com/icosm/"

	useEffect(() => {
		const menu = menu_model.get_menu(inSideMenu, '/', 0, 0, true);
		setMenu(menu)
	}, [inSideMenu])

    const handleHover = (isOpen, i) => {
        !isOpen && btnRef.current[i].click()
	}

	// 		--------------------------------		--------------------------------		---------

	useEffect(() => {
		setPanel(
		    <Popover.Panel 
				ref={popperElement}
				className="mt-[68px] lg:px-9 panel !bg-icosm-quaternary h-[255px] w-full shadow-lg z-50 !top-0"
				style={styles.popper}
				{...attributes.popper}
				>
                <div className="container !pt-0">
                    {tiles[current] && 
                        <div className="flex py-4 gap-9 relative w-full mx-auto max-w-screen-menu-xl">
                            {/* side section */}
                            <div style={{ backgroundImage: `url(${img_path}${tiles[current].img})`}}  className="max-w-full lg:w-[289px] h-[221px] bg-cover"/>

                            {/* main section */}
                            <div className="section-main col-span-2 h-full">
                                <div className="items-start list flex flex-wrap flex-col">
                                    {tiles[current]?.list.map((el, i) => 
                                            <Popover.Button 
                                                key={i} as={Link} to={el.link}
                                                className="md:mb-4 text-icosm-primary hover:underline hover:text-icosm-tertiary text-[1.2rem] md:text-[1rem]">
                                                {el.title}
                                            </Popover.Button>)
                                        }
                                    </div>
                                
                            </div>
                        </div>
                    }
                </div>
			</Popover.Panel>)
	}, [current])

   // 		--------------------------------		--------------------------------		---------

   return (
    inSideMenu ? (
        <div className="mb-4">
            {mainMenu.length > 0 && mainMenu?.filter(Boolean).map((el, i) => {
                return  <Disclosure key={i} as="div">
                            <Disclosure.Button as="button"
                                className="disclosure-btn !font-bold w-full text-black ui item text-icosm-primary underline decoration-transparent hover:decoration-icosm-primary transition-all duration-300 ease-in-out text-left">
                                {el.name}
                            </Disclosure.Button>
                            <Disclosure.Panel className="!mt-0 pl-6 flex flex-col">
                                {tiles[el.key]?.list.map((item, i) => {
                                    return <Link key={i} className="mb-4 text-icosm-primary hover:underline hover:text-icosm-tertiary text-icosm_base" to={item.link} onClick={() => onMenuChange?.(false)}>{item.title}</Link>
                                })}
                            </Disclosure.Panel>
                        </Disclosure>
            })}
        </div>)
    :
    <Popover.Group className={`flex justify-between w-full lg:ml-[80px] mr-4 mega-menu flex-row items-center h-[46px]`}>
        {mainMenu.length > 0  && mainMenu?.filter(Boolean).map((el, i) => {
            return <Popover key={i}>
            {({ open, close }) => (
            <>
                {/* Main Menu */}
                <div className="relative md:z-10">
                    <div className="xl:px-1.5 2xl:p-2"
                    >
                        <Popover.Button
                            key={i}
                            ref={el => btnRef.current[i] = el}
                            onMouseEnter={() => handleHover(open, i)}
                            onClick={() => {
                                setCurrent(el.key)
                            }}
                            className={clsn(cls, el.cls,
                            "items-center uppercase text-white hover:text-icosm-gold-50 rounded-md text-[11px]",
                            open ? "open underline" : "!decoration-transparent", "popover-btn button group inline-flex items-end")}>
                            <span className="max-w-[80%] text-left sm:max-w-none sm:text-center">{el.name}</span>
                        </Popover.Button>
                    </div>
                </div>

                {/* Dropdown Menu */}
                { panel }
            </>
            )}
        </Popover>     
        })}
    </Popover.Group>
  )
}

export default IcosmMegaMenu
